import * as React from 'react';
import { SegmentInfo } from './segment-info';
import { AppFooter } from '../app/app-footer';
import { PassengerDetailList } from './passenger-detail-list';

export class Segment extends React.Component {
  public render() {
    return (
      <div className="segment">
        <SegmentInfo/>
        <br/>
        <PassengerDetailList/>
        <br/>
        <AppFooter/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/segment/segment.tsx